import { createContext, useContext } from 'react';
export const ActionsContext = /*#__PURE__*/createContext({
  statuses: {},
  siteInfo: {
    externalViewer: false
  },
  handlers: {},
  enabledActions: [],
  uiConfig: {}
});
export const useStatuses = () => {
  const {
    statuses
  } = useContext(ActionsContext);
  if (!statuses) {
    throw new Error('useStatuses must be used within an ActionsExtension Provider');
  }
  return statuses;
};
export const useSiteInfo = () => {
  const {
    siteInfo
  } = useContext(ActionsContext);
  if (!siteInfo) {
    throw new Error('useSiteInfo must be used within an ActionsExtension Provider');
  }
  return siteInfo;
};
export const useUiConfig = () => {
  const {
    uiConfig
  } = useContext(ActionsContext);
  return uiConfig;
};
export const useActionHandlers = () => {
  const {
    handlers
  } = useContext(ActionsContext);
  if (!handlers) {
    throw new Error('useActionHandlers must be used within an ActionsExtension Provider');
  }
  return handlers;
};
export const useEnabledActions = () => {
  const {
    enabledActions
  } = useContext(ActionsContext);
  if (!enabledActions) {
    throw new Error('useEnabledActions must be used within an ActionsExtension Provider');
  }
  return enabledActions;
};
export const useAutoInvokeOverride = () => {
  const {
    autoInvokeOverride
  } = useContext(ActionsContext);
  return autoInvokeOverride;
};
export const useResolveCorrectedDomains = () => {
  const {
    resolveCorrectedDomains
  } = useContext(ActionsContext);
  return resolveCorrectedDomains;
};
//# sourceMappingURL=context.js.map